import { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { validateToken, submitPasswordRequest } from '../api/passwordRecovery';

export default function PasswordRecoveryForm() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('t');

  const [phase, setPhase]       = useState('validating'); // validating | form | submitting
  const [email, setEmail]       = useState('');
  const [fieldError, setFieldError] = useState('');

  // ── GET /password-recovery/view?t=TOKEN ──────────────────────────────────
    useEffect(() => {
        if (!token) {
            navigate('/error/link-expired', { replace: true });
            return;
        }

        let cancelled = false;

        validateToken(token)
            .then(data => {
                if (cancelled) return;
                if (data.valid) setPhase('form');
                else navigate('/error/link-expired', { replace: true });
            })
            .catch(err => {
                if (cancelled) return;
                navigate('/error/link-expired', { replace: true });
            });

        return () => {
            cancelled = true;
        };
    }, [token, navigate]);

  // ── POST /password-recovery/request ──────────────────────────────────────
  async function handleSubmit(e) {
    e.preventDefault();
    setFieldError('');
    if (!email.trim()) { setFieldError('Inserisci il tuo indirizzo email.'); return; }

    setPhase('submitting');
    try {
      const data = await submitPasswordRequest(token, email.trim());
      switch (data.status) {
        case 'success':       navigate('/success', { replace: true }); break;
        case 'email-mismatch':
          setFieldError(data.error || 'Email inserita non corretta.');
          setPhase('form');
          break;
        case 'link-expired':  navigate('/error/link-expired', { replace: true }); break;
        default:              navigate('/error/generic', { replace: true });
      }
    } catch {
      navigate('/error/generic', { replace: true });
    }
  }

  if (phase === 'validating') {
    return (
        <div className="card card--form">
          <div className="loader">
            <div className="loader-spinner" />
            <span>Verifica del link in corso…</span>
          </div>
        </div>
    );
  }

  return (
      <div className="card card--form">
        <h2>Sblocco Documento</h2>
        <p style={{ marginBottom: '1.5rem', color: '#555' }}>
          Per ricevere nuovamente la password, indica la mail su cui hai ricevuto
          il documento per verifica:
        </p>

        {fieldError && (
            <div className="error-msg" role="alert">{fieldError}</div>
        )}

        <form onSubmit={handleSubmit} noValidate>
          <input type="hidden" name="t" value={token || ''} />

          <div className="form-group">
            <label htmlFor="userEmail">Email:</label>
            <input
                id="userEmail"
                name="userEmail"
                type="text"
                placeholder="Inserisci la tua email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                disabled={phase === 'submitting'}
                required
            />
          </div>

          <button className="btn" type="submit" disabled={phase === 'submitting'}>
            {phase === 'submitting' ? 'Invio in corso…' : 'Invia'}
          </button>
        </form>
      </div>
  );
}
